import React from "react";

// Function component to display error message
export default function ErrorMessage({ message }) {
  // Return JSX element to render error message
  return (
    <div className="text-danger" style={{ fontSize: "12px" }}>
      {message}
    </div>
  );
}
